import { api } from './index';

const BASE_PATH = '/api/internal/task_categories';

export type TaskCategory = {
  id: number;
  name: string;
  description: string;
  taskDefinitionsCount: number;
  discardedAt?: string;
  discarded: boolean;
  humanCreatedAt: string;
  humanDiscardedAt?: string;
};

export interface TaskCategoryForm {
  id?: number;
  name: string;
  description: string;
}

export const taskCategoriesApi = {
  index(scope?: 'active' | 'discarded'): Promise<Array<TaskCategory>> {
    const params = scope === 'discarded' ? { scope: 'discarded' } : {};

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then(response => response.data.taskCategories);
  },
  create(taskCategoryForm: TaskCategoryForm): Promise<TaskCategory> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { taskCategory: taskCategoryForm },
    }).then(response => response.data.taskCategory);
  },
  update(taskCategoryForm: Partial<TaskCategoryForm>): Promise<TaskCategory> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${taskCategoryForm.id}`,
      data: { taskCategory: taskCategoryForm },
    }).then(response => response.data.taskCategory);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    });
  },
};
